module.exports = __webpack_public_path__ + "img/Microsoft Authorized Service Provider.158d49a1.svg";